import React from 'react';
import { Box, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SalovareSelectField from '../../common/SalovareSelectField';
import { FIELD_PLACEHOLDER_COLOR } from '../../common/formFieldStyles';
import { CUSTOMER_IMPORT_TARGET_FIELDS } from '../../../utils/customerFileImport';

const CustomerImportMappingSelectForm = ({
  sourceFields,
  mappings,
  onChangeMapping,
}) => {
  const { t } = useTranslation();
  const mappedByTarget = new Map((mappings || []).map((mapping) => [mapping.targetField, mapping.sourceField]));
  const usedSources = new Set((mappings || []).map((mapping) => mapping.sourceField));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        pt: 1,
        pb: 2,
      }}
    >
      {CUSTOMER_IMPORT_TARGET_FIELDS.map((field) => {
        const value = mappedByTarget.get(field.id) || '';
        return (
          <SalovareSelectField
            key={field.id}
            label={t(`customersManagement.import.fields.${field.id}`)}
            value={value}
            onChange={(event) => onChangeMapping(field.id, event.target.value)}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <Typography component="span" sx={{ color: FIELD_PLACEHOLDER_COLOR }}>
                    {t('customersManagement.import.mappingNone')}
                  </Typography>
                );
              }
              return selected;
            }}
          >
            <MenuItem value="">
              <Typography component="span" sx={{ color: FIELD_PLACEHOLDER_COLOR }}>
                {t('customersManagement.import.mappingNone')}
              </Typography>
            </MenuItem>
            {(sourceFields || []).map((sourceField) => (
              <MenuItem
                key={sourceField}
                value={sourceField}
                disabled={usedSources.has(sourceField) && sourceField !== value}
                sx={{ whiteSpace: 'normal' }}
              >
                {sourceField}
              </MenuItem>
            ))}
          </SalovareSelectField>
        );
      })}
    </Box>
  );
};

export default CustomerImportMappingSelectForm;
